import axios from 'axios';
import { baseUrl, STATUS_CODES } from './constant';
import { store } from '../redux/store';
import AuthActions from '../redux/auth/actions';
const { logout } = AuthActions;

const Api = (method, urlData, params) => {
	return new Promise((resolve, reject) => {
		const url = `${baseUrl}${urlData}`;
		const headers = {};

		// Log request details
		console.log('=== API REQUEST START ===');
		console.log('Method:', method);
		console.log('URL:', url);
		console.log('Params type:', typeof params);
		console.log('Params instanceof FormData:', params instanceof FormData);
		
		if (params instanceof FormData) {
			console.log('FormData contents:');
			for (let [key, value] of params.entries()) {
				if (value instanceof File) {
					console.log(`  ${key}: File(${value.name}, ${value.size} bytes, ${value.type})`);
				} else {
					console.log(`  ${key}: ${value}`);
				}
			}
		} else {
			console.log('Params:', params);
		}

		if (store.getState().auth.accessToken) {
			headers['Authorization'] = 'Bearer ' + store.getState().auth.accessToken;
			console.log('Auth token present: YES');
		} else {
			console.log('Auth token present: NO');
		}
		
		console.log('Headers:', headers);
		
		let axiosObj = {
			method: method,
			url: url,
			data: params,
			headers: headers,
		};

		// Add timeout for large file uploads
		if (params instanceof FormData) {
			axiosObj.timeout = 15 * 60 * 1000; // 15 minutes for file uploads
			console.log('Set timeout to 15 minutes for file upload');
		}

		// if (params.apiCancelToken) axiosObj['cancelToken'] = params.apiCancelToken;

		const startTime = Date.now();
		console.log('Request started at:', new Date(startTime).toISOString());

		axios(axiosObj)
			.then((response) => {
				const endTime = Date.now();
				const duration = endTime - startTime;
				console.log('=== API RESPONSE SUCCESS ===');
				console.log('Status:', response.status);
				console.log('Duration:', duration + 'ms');
				console.log('Response headers:', response.headers);
				console.log('Response data type:', typeof response.data);
				console.log('Response data:', response.data);
				console.log('Request completed at:', new Date(endTime).toISOString());
				resolve(response);
			})
			.catch((error) => {
				const endTime = Date.now();
				const duration = endTime - startTime;
				console.log('=== API RESPONSE ERROR ===');
				console.log('Error type:', error.name);
				console.log('Error message:', error.message);
				console.log('Duration:', duration + 'ms');
				console.log('Error code:', error.code);
				
				if (error.response) {
					console.log('Response status:', error.response.status);
					console.log('Response headers:', error.response.headers);
					console.log('Response data:', error.response.data);
				} else if (error.request) {
					console.log('No response received');
					console.log('Request:', error.request);
				} else {
					console.log('Request setup error:', error.message);
				}
				
				if (error && error.response && error.response.status === STATUS_CODES.UNAUTHORIZED) {
					store.dispatch(logout());
				}

				if (error && error.response) reject(error);
				else {
					console.log('Rejecting with full error object:', error);
					reject(error);
				}
			});
	});
};
export default Api;
